// @ts-check

export const ASK_QUESTIONS_MAX_OUTPUT_CHARS = 2560

export const ASK_QUESTIONS_SKIP_ONE_LINE = "Prefiero no responder esta pregunta"

export const ASK_QUESTIONS_SKIP_ALL_NONE = "Prefiero no responder las preguntas"

export const ASK_QUESTIONS_SKIP_REMAINING =
  "Prefiero no responder esta pregunta"

export const ASK_QUESTIONS_CUSTOM_PLACEHOLDER = "Otro (escribe aquí)"
